import { useState } from "react";
import { UpsertTemplateModal } from "./UpsertTemplateModal";

export type Mode = "create_only" | "upsert";

export const useUpsertTemplateModal = () => {
  const [modalIsOpenWithMode, setModalIsOpenWithMode] = useState<Mode | null>(
    null,
  );

  const handleOpenModal = (mode: Mode = "create_only") => {
    setModalIsOpenWithMode(mode);
  };

  return {
    modalElement: (
      <div onSubmit={e => e.stopPropagation()}>
        <UpsertTemplateModal
          mode={modalIsOpenWithMode}
          onClose={() => setModalIsOpenWithMode(null)}
        />
      </div>
    ),
    openModal: handleOpenModal,
  };
};
